import { Checkbox, Grid, styled } from '@nextiva/next-ui-components';
import { pxToRem } from 'utils/pxToRemConverter';
import colors from 'styles/application/_base/_variables.scss';

// The styles in here use a lot of `!important` because of a weird bug that causes MUI styles to be injected AFTER the Emotion styles
// Im not sure what the cause is, but the fix for now is to use !important until the bug can be investigated
export const CheckboxStyles = styled(Grid)`
  padding: 22px 0 0 22px;
  .MuiCheckbox-root {
    color: ${colors.secondaryColor};
  }
  .MuiCheckbox-colorPrimary.Mui-checked {
    color: ${colors.primaryBlue};
  }
  .MuiIconButton-root {
    padding: 6px;
  }
  .MuiIconButton-colorPrimary:hover,
  .MuiIconButton-root:hover,
  .MuiIconButton-colorPrimary:hover,
  .MuiIconButton-root:hover {
    background-color: initial;
  }
  .MuiTypography-body1 {
    color: #555 !important; // VS-UI uses 'normalize.css' and #333 -- PA-UI does not currently use normalize.css so #555 is a closer match
    font-family: Lato, sans-serif !important;
    font-size: 0.875rem;
    letter-spacing: 0.21px;
  }
`;

// .MuiButtonBase-root is a fix for styles being reordered on dev
export const CheckboxStyled = styled(Checkbox)`
  &.MuiButtonBase-root {
    position: relative;
    width: inherit;
    opacity: 1;
  }
`;

export const SelectiveTable = styled(Grid)`
  .selective-row {
    display: flex;
    align-items: center;
    padding: 16px 8px;
    border-bottom: 1px solid #e9edf5;

    .selective-text {
      font-size: ${pxToRem('14px')};
    }

    .active-label {
      margin-left: 10px;
      padding: 2px 8px;
      border-radius: 3px;
      background-color: #e3ecf5;
      font-size: ${pxToRem('12px')};
      color: #000;
    }
  }

  .selective-header {
    margin-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid ${colors.dividerColor};
    color: ${colors.secondaryColor};
    font-size: ${pxToRem('16px')};
    line-height: 24px;
    letter-spacing: 0.4px;
    font-weight: 800;
    font-family: Lato, sans-serif !important;
  }
`;

export const AddCondition = styled(Grid)`
  margin-top: 24px;
`;

export const PhoneNumContainer = styled(Grid)`
  display: flex;
  align-items: center;
`;
